import { Component, inject } from '@angular/core';
import { CoBrandService } from 'src/app/core/services/co-brand.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { CommonService } from '../../services/common.service';
import { isAssetOnboardingRoute } from '../../Helper/common-utils';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-footer-new',
    templateUrl: './footer-new.component.html',
    styleUrls: ['./footer-new.component.css'],
    imports: [NgIf]
})
export class FooterNewComponent {
    /** Partner brand (logo, name) when the marketplace runs as a co-brand. */
    readonly coBrand = inject(CoBrandService);
  year: any;
  privacyPolicyUrl: string = '';
  userAggrementUrl: string = '';
  onboardPage: any;
  docUrl: any;

  constructor(
    public commonService: CommonService,
    public router: Router,
  ) {

  }
  ngOnInit(): void {
    this.year = new Date().getFullYear();
    this.commonService.getDocument().subscribe({
        next: (docUrls) => {
            this.docUrl = docUrls;
        },
        error: (err) => {
            console.error('Error fetching documents:', err);
        }
    });
    this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe(async (data) => {
      this.onboardPage = isAssetOnboardingRoute(data.url);
    });
  }
  /**
   * scroll to top
   */
  // bottomtotop() {
  //   window.scrollTo(0, 0);
  // }
}